/**
 * Helper function to convert Redux filterCriteria to rating method string
 * @param {Object} filterCriteria - Redux state renewalShopping.filterCriteria.ratingMethod {tier: boolean, age: boolean}
 * @returns {string|null} - 'Composite4Tier', 'AgeBanded', or null
 */
export function convertFilterCriteriaToRatingMethod(filterCriteria) {
    if (!filterCriteria || (!filterCriteria.tier && !filterCriteria.age)) {
        return null;
    }
    if (filterCriteria.tier && !filterCriteria.age) {
        return 'Composite4Tier';
    }
    if (filterCriteria.age && !filterCriteria.tier) {
        return 'AgeBanded';
    }
    return null;
}
